import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import global from './config/global';

export const getNamespaceFromPath = () => {
	const path = window.location.pathname.split('/');
	return path[1] || 'common'; // Default namespace (if no namespace exists)
};

i18n
	.use(HttpBackend) // Load translations from the backend
	.use(LanguageDetector) // Detect language automatically
	.use(initReactI18next)
	.init({
		fallbackLng: 'en', // Default language
		supportedLngs: ['en', 'de', 'ja', 'zh-TW', 'zh-CN', 'th', 'it'],
		ns: 'common',
		defaultNS: 'common',
		fallbackNS: 'common',
		debug: false, // Enable debugging in dev mode
		interpolation: {
			escapeValue: false, // React already escapes by default
		},
		backend: {
			loadPath: `${global.apisUrl}/locales/{{lng}}/{{ns}}`,
		},
		detection: {
			order: ['querystring', 'localStorage', 'navigator'], // Prioritization
			caches: ['localStorage'], // Save the selected language
		},
		lng: localStorage.getItem('i18nextLng') || 'en',
	});

export default i18n;
